const TOKEN_KEY = 'token'
const REFRESH_KEY = 'refreshToken'
const USER_KEY = 'scannerUser'
const EVENT_KEY = 'selectedEvent'

export function getToken() {
  return localStorage.getItem(TOKEN_KEY)
}

export function getRefreshToken() {
  return localStorage.getItem(REFRESH_KEY)
}

export function setTokens(token, refreshToken) {
  if (token) localStorage.setItem(TOKEN_KEY, token)
  if (refreshToken) localStorage.setItem(REFRESH_KEY, refreshToken)
}

export function clearSession() {
  localStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem(REFRESH_KEY)
  localStorage.removeItem(USER_KEY)
  sessionStorage.removeItem(EVENT_KEY)
}

export function getStoredUser() {
  try {
    return JSON.parse(localStorage.getItem(USER_KEY) || 'null')
  } catch {
    return null
  }
}

export function setStoredUser(user) {
  localStorage.setItem(USER_KEY, JSON.stringify(user || {}))
}

export function getSelectedEvent() {
  try {
    return JSON.parse(sessionStorage.getItem(EVENT_KEY) || 'null')
  } catch {
    return null
  }
}

export function setSelectedEvent(event) {
  if (!event) sessionStorage.removeItem(EVENT_KEY)
  else sessionStorage.setItem(EVENT_KEY, JSON.stringify(event))
}

export function getScanHistory(eventId) {
  try {
    return JSON.parse(sessionStorage.getItem(`scanHistory:${eventId}`) || '[]')
  } catch {
    return []
  }
}

export function pushScanHistory(eventId, item) {
  const next = [item, ...getScanHistory(eventId)].slice(0, 8)
  sessionStorage.setItem(`scanHistory:${eventId}`, JSON.stringify(next))
  return next
}
